module.exports = __webpack_public_path__ + "routes/login/napisPZ.jpg?95058303";


//////////////////
// WEBPACK FOOTER
// ./routes/login/napisPZ.jpg
// module id = 1063
// module chunks = 0